import { mediaMaxWidth2 } from 'src/styles/layout';
import styled from 'styled-components';
import { Subtitle } from 'src/components/PortalList/PortalList.styles';

export const StatusSubtitle = styled(Subtitle)`
  ${mediaMaxWidth2.tabletSmall`
    display: none;
  `}
`;
